/**
 * Analytics Layout Component
 * Main layout wrapper with sidebar and header
 */

import { useState } from 'react';
import { Menu } from 'lucide-react';
import Sidebar from './Sidebar';
import Header from './Header';
import { PermissionFailureBanner } from '@shared/auth';
import ErrorBoundary from '../ErrorBoundary';

const AnalyticsLayout = ({ children, title, subtitle }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gray-50 flex overflow-x-hidden">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col min-h-screen">
        {/* Top Header */}
        <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-30">
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="flex items-center justify-between h-16">
              <div className="flex items-center space-x-4">
                {/* Mobile Menu Button */}
                <button
                  onClick={() => setSidebarOpen(true)}
                  className="lg:hidden p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg"
                  aria-label="Open navigation menu"
                >
                  <Menu size={24} />
                </button>

                {/* Page Title */}
                <div>
                  <h1 className="text-xl font-bold text-gray-900">{title}</h1>
                  {subtitle && <p className="text-sm text-gray-500">{subtitle}</p>}
                </div>
              </div>

              {/* Header Right (ProductSwitcher + User) */}
              <Header />
            </div>
          </div>
        </header>

        {/* Tells the user their controls are hidden because permissions could
            not be verified, rather than because they are not allowed. */}
        <PermissionFailureBanner />

        {/* Page Content */}
        <main className="flex-1 overflow-auto">
          <div className="max-w-full px-4 sm:px-6 lg:px-4 py-8">
            <ErrorBoundary>{children}</ErrorBoundary>
          </div>
        </main>
      </div>
    </div>
  );
};

export default AnalyticsLayout;
